import {defineStore} from 'pinia'
import api from '@/services/api'
import {useItemDataStore} from '@/stores/itemData'

export const useComponentStructureStore = defineStore('componentStructure', {
    state: () => ({
        data: {},
        items: []
    }),
    getters: {
        get: (state) => (componentId) => {
            return state.items.filter(o => o.modulecomponentsID === componentId || o.modulecomponentsId === componentId)
        },
        getItem: (state) => (id) => {
            return state.items.find(o => o.id === id)
        }
    },
    actions: {
        // todo - DEPRECATED - See actions get() below.
        setData(data) {
            this.data = data
        },
        setItems(items) {
            this.items = items
        },
        // Loads all structure data and adds it to itemDataStore, then stores all structure IDs associated to their
        // component ID, allowing for the get action to return an array of a component's structure items.
        async init() {
            // Loads ALL structure data.
            const obj = await api.get('api/component/modulestructure', {
                params: {
                    sort: 'displayOrder'
                }
            })
            
            let items = obj.data.items
            this.setItems(items)
            
            const itemDataStore = useItemDataStore()
            itemDataStore.setItems({
                tableName: 'modulestructure',
                objs: items,
            })
            
            let data = {}
            
            items.forEach((obj) => {
                let componentId = obj.modulecomponentsID || obj.modulecomponentsId
                if (data[componentId] === undefined) {
                    data[componentId] = []
                }
                
                data[componentId].push(obj.id)
            })
            
            this.setData(data)
        }
    }
})